export type Catalogue = {groups:{id?:string;title:string;section:string;fields:{id:string;label:string;defaultStatus:string;audience?:string;allowedScopes?:string[]}[]}[];equipmentCategories:{id?:string;title:string;options:{id:string;label:string;defaultStatus:string}[]}[]};
export const CATALOGUE:Catalogue = {
  "groups": [
    {
      "id": "pricing-availability",
      "title": "Price & availability",
      "section": "specifications",
      "fields": [
        {
          "id": "askingPriceRetail",
          "label": "Retail asking price (CAD)",
          "defaultStatus": "Not supplied",
          "audience": "public"
        },
        {
          "id": "askingPriceWholesale",
          "label": "Wholesale asking price (CAD)",
          "defaultStatus": "Not supplied",
          "audience": "dealer-only"
        },
        {
          "id": "availabilityStatus",
          "label": "Availability",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "allocationState",
          "label": "Sale/allocation state",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "identity-mileage",
      "title": "Vehicle identity and mileage",
      "section": "specifications",
      "fields": [
        {
          "id": "year",
          "label": "Year",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "make",
          "label": "Make",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "model",
          "label": "Model",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "trim",
          "label": "Exact trim",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "bodyStyle",
          "label": "Body style",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "doors",
          "label": "Doors",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "stockNumber",
          "label": "Stock number",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "vin",
          "label": "VIN",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "odometerKm",
          "label": "Kilometres (odometer reading)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "conditionClass",
          "label": "Condition class (new / used / certified)",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "location",
          "label": "Vehicle location",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "listingDescription",
          "label": "Listing description",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "powertrain-fuel-efficiency",
      "title": "Powertrain, fuel and efficiency",
      "section": "specifications",
      "fields": [
        {
          "id": "engineDescription",
          "label": "Engine / cylinder type",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "engineDisplacement",
          "label": "Engine displacement",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "transmission",
          "label": "Transmission / gears",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "drivetrain",
          "label": "Drivetrain (FWD/RWD/AWD/4x4)",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "fuelType",
          "label": "Fuel type",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "fuelEconomyCity",
          "label": "City consumption (L/100 km)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "fuelEconomyHighway",
          "label": "Highway consumption (L/100 km)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "electricRange",
          "label": "Electric range (EV/plug-in hybrid)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "cylinders",
          "label": "Cylinders",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "horsepower",
          "label": "Horsepower",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "torque",
          "label": "Torque",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "fuelEconomyCombined",
          "label": "Combined consumption (L/100 km)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "fuelTankCapacity",
          "label": "Fuel tank capacity (L)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "batteryCapacity",
          "label": "Battery capacity (kWh)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "acCharging",
          "label": "AC charging capability",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "dcCharging",
          "label": "DC charging capability",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "cabin-body-colours",
      "title": "Cabin, body and colours",
      "section": "specifications",
      "fields": [
        {
          "id": "exteriorColour",
          "label": "Exterior colour",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "interiorColour",
          "label": "Interior colour",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "seatingCapacity",
          "label": "Passenger/seating capacity",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "seatMaterial",
          "label": "Seat material / upholstery",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "cabType",
          "label": "Cab type (trucks)",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "dimensions-towing",
      "title": "Dimensions and towing",
      "section": "specifications",
      "fields": [
        {
          "id": "exteriorDimensions",
          "label": "Exterior dimensions (L x W x H)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "wheelbase",
          "label": "Wheelbase",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "bedLength",
          "label": "Bed length (trucks)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "payloadCapacity",
          "label": "Payload capacity",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "maxTowingCapacity",
          "label": "Maximum towing capacity",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "gvwr",
          "label": "GVWR",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "cargoCapacity",
          "label": "Cargo capacity",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "curbWeight",
          "label": "Curb weight (kg)",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "groundClearance",
          "label": "Ground clearance (mm)",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "packages",
      "title": "Packages and confirmed installed options",
      "section": "equipment",
      "fields": [
        {
          "id": "installedPackages",
          "label": "Installed packages / trim bundles",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "confirmedOptionsEvidence",
          "label": "Evidence source for confirmed options",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "factoryPackages",
          "label": "Factory package / option codes",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "aftermarketEquipment",
          "label": "Aftermarket equipment / modifications",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "inspection-record",
      "title": "Inspection record",
      "section": "condition",
      "fields": [
        {
          "id": "inspectionDate",
          "label": "Inspection date",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "inspectorName",
          "label": "Inspector name",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "inspectionSummary",
          "label": "Inspection summary",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "inspection-exterior",
      "title": "Exterior inspection",
      "section": "condition",
      "fields": [
        {
          "id": "exteriorBodyPanels",
          "label": "Body panels and panel gaps",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "exteriorPaintFinish",
          "label": "Paint and finish",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "exteriorGlassLights",
          "label": "Glass, lamps and mirrors",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "exteriorTrim",
          "label": "Trim and mouldings",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "exteriorBumpers",
          "label": "Bumpers",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "exteriorCorrosion",
          "label": "Exterior rust / corrosion",
          "defaultStatus": "Not inspected"
        }
      ]
    },
    {
      "id": "inspection-interior",
      "title": "Interior inspection",
      "section": "condition",
      "fields": [
        {
          "id": "interiorSeatsUpholstery",
          "label": "Seats and upholstery",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "interiorDashboardControls",
          "label": "Dashboard, switches and controls",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "interiorHeadlinerCarpet",
          "label": "Headliner and carpet",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "interiorDoorPanels",
          "label": "Door panels",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "interiorElectronics",
          "label": "Interior electronics operation",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "interiorOdours",
          "label": "Odours (smoke / pet / must)",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "interiorWear",
          "label": "General interior wear",
          "defaultStatus": "Not inspected"
        }
      ]
    },
    {
      "id": "inspection-mechanical",
      "title": "Mechanical inspection",
      "section": "condition",
      "fields": [
        {
          "id": "mechanicalEngineOperation",
          "label": "Engine operation / cold start",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalTransmissionOperation",
          "label": "Transmission and shifting",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalBrakes",
          "label": "Brakes",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalSuspension",
          "label": "Suspension",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalSteering",
          "label": "Steering",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalExhaust",
          "label": "Exhaust",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalFluidsLeaks",
          "label": "Fluids and leaks",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalBatteryCharging",
          "label": "Battery and charging system",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalHeatingCooling",
          "label": "Heating and air conditioning",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "mechanicalFourWheelDrive",
          "label": "4x4 / AWD system operation",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "diagnosticCodes",
          "label": "Diagnostic codes / warning lights",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "roadTest",
          "label": "Road-test observations",
          "defaultStatus": "Not inspected"
        }
      ]
    },
    {
      "id": "inspection-structural",
      "title": "Structural inspection",
      "section": "condition",
      "fields": [
        {
          "id": "structuralFrameUnibody",
          "label": "Frame / unibody condition",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "structuralAccidentEvidence",
          "label": "Evidence of accident damage",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "structuralRust",
          "label": "Structural rust / corrosion",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "structuralFloodIndicators",
          "label": "Flood damage indicators",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "structuralPriorRepairs",
          "label": "Prior paint / panel repair evidence",
          "defaultStatus": "Not inspected"
        }
      ]
    },
    {
      "id": "inspection-tires",
      "title": "Tire and wheel inspection",
      "section": "condition",
      "fields": [
        {
          "id": "tireTreadDepth",
          "label": "Tread depth by corner",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "tireConditionAge",
          "label": "Tire condition / age",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "tireMatchedSet",
          "label": "Matched set",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "wheelCondition",
          "label": "Wheel / rim condition",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "spareAndJack",
          "label": "Spare tire and jack",
          "defaultStatus": "Not inspected"
        },
        {
          "id": "tpmsOperation",
          "label": "Tire pressure monitoring sensors",
          "defaultStatus": "Not inspected"
        }
      ]
    },
    {
      "id": "damage-map",
      "title": "Damage map and linked condition notes",
      "section": "condition",
      "fields": [
        {
          "id": "damageMapEntries",
          "label": "Marked damage / condition points",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "history-registration",
      "title": "History, odometer, registration and prior use",
      "section": "history",
      "fields": [
        {
          "id": "accidentHistory",
          "label": "Accident history",
          "defaultStatus": "Unknown"
        },
        {
          "id": "registrationStatus",
          "label": "Registration status",
          "defaultStatus": "Unknown"
        },
        {
          "id": "priorUse",
          "label": "Prior use",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "outOfProvinceHistory",
          "label": "Out-of-province history",
          "defaultStatus": "Unknown"
        },
        {
          "id": "odometerDeclaration",
          "label": "Odometer declaration / branding",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "lienStatus",
          "label": "Outstanding liens",
          "defaultStatus": "Unknown"
        },
        {
          "id": "importHistory",
          "label": "Import history",
          "defaultStatus": "Unknown"
        },
        {
          "id": "ownershipHistory",
          "label": "Previous owners",
          "defaultStatus": "Unknown"
        },
        {
          "id": "warrantyStatus",
          "label": "Remaining warranty",
          "defaultStatus": "Unknown"
        },
        {
          "id": "serviceHistory",
          "label": "Maintenance history",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "keysIncluded",
          "label": "Keys / remotes included",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "recallStatus",
          "label": "Outstanding recall status",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "disclosures-notes",
      "title": "Disclosures, known issues, repairs and seller notes",
      "section": "history",
      "fields": [
        {
          "id": "knownIssues",
          "label": "Known issues",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "repairNotes",
          "label": "Repair notes",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "sellerDisclosures",
          "label": "Disclosures to buyers",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "sellerNotes",
          "label": "Seller notes",
          "defaultStatus": "Not supplied",
          "allowedScopes": [
            "buyer-facing",
            "internal-private"
          ]
        }
      ]
    },
    {
      "id": "media-evidence",
      "title": "Photos and videos by category",
      "section": "media",
      "fields": [
        {
          "id": "photosExterior",
          "label": "Exterior photos",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "photosInterior",
          "label": "Interior photos",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "photosEngine",
          "label": "Engine bay photos",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "photosUndercarriage",
          "label": "Undercarriage photos",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "photosTires",
          "label": "Tire photos",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "photosDamageCloseups",
          "label": "Damage close-up photos",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "videoWalkaround",
          "label": "Walkaround video",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "recordingColdStart",
          "label": "Cold-start recording",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "documents",
      "title": "Documents",
      "section": "history",
      "fields": [
        {
          "id": "carfaxCanadaReport",
          "label": "CARFAX Canada report",
          "defaultStatus": "Not supplied",
          "audience": "permission-open"
        },
        {
          "id": "inspectionReportDocument",
          "label": "Inspection report",
          "defaultStatus": "Not supplied",
          "audience": "permission-open"
        },
        {
          "id": "serviceRecords",
          "label": "Service / maintenance records",
          "defaultStatus": "Not supplied",
          "audience": "permission-open"
        },
        {
          "id": "originalWindowSticker",
          "label": "Original window sticker / build sheet",
          "defaultStatus": "Not supplied",
          "audience": "permission-open"
        },
        {
          "id": "registrationDocument",
          "label": "Registration / title information",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "odometerDeclarationDocument",
          "label": "Odometer declaration document",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "disclosureRecords",
          "label": "Disclosure & repair records",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "pickup-transport",
      "title": "Pickup and transport",
      "section": "delivery",
      "fields": [
        {
          "id": "pickupLocation",
          "label": "Pickup location",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "pickupReadiness",
          "label": "Pickup / release readiness",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "viewingAppointment",
          "label": "Viewing appointment availability",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "transportOffered",
          "label": "Transport / delivery availability",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "transportQuoteStatus",
          "label": "Confirmed transport quote status",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "pickupInstructions",
          "label": "Pickup instructions",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "releaseDocuments",
          "label": "Release documents",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "carrier",
          "label": "Transport carrier",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "estimatedDelivery",
          "label": "Estimated delivery",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "transportQuote",
          "label": "Transport quote (CAD)",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "vehicle-engagement",
      "title": "Vehicle-specific Q&A, evidence requests and updates",
      "section": "questions",
      "fields": [
        {
          "id": "qaThread",
          "label": "Vehicle-specific Q&A",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "evidenceRequestsOpen",
          "label": "Open evidence requests",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "changeNotifications",
          "label": "Change notifications (price / condition / status)",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "publicUpdatesLog",
          "label": "Public update history for this vehicle",
          "defaultStatus": "Not supplied"
        }
      ]
    },
    {
      "id": "source-review",
      "title": "Information source & review",
      "section": "specifications",
      "fields": [
        {
          "id": "informationSource",
          "label": "Information source",
          "defaultStatus": "Synthetic preview record"
        },
        {
          "id": "dataReviewedBy",
          "label": "Reviewed by",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "dataReviewDate",
          "label": "Review date",
          "defaultStatus": "Not supplied"
        },
        {
          "id": "dataVerificationStatus",
          "label": "Verification status",
          "defaultStatus": "Not confirmed"
        }
      ]
    }
  ],
  "equipmentCategories": [
    {
      "id": "comfort-seating",
      "title": "Comfort and seating",
      "options": [
        {
          "id": "heatedFrontSeats",
          "label": "Heated front seats",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "heatedRearSeats",
          "label": "Heated rear seats",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "ventilatedFrontSeats",
          "label": "Ventilated / cooled front seats",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerDriverSeat",
          "label": "Power driver seat",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerPassengerSeat",
          "label": "Power passenger seat",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "driverSeatMemory",
          "label": "Driver seat memory",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "leatherSeatingSurfaces",
          "label": "Leather seating surfaces",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "heatedSteeringWheel",
          "label": "Heated steering wheel",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "lumbarSupport",
          "label": "Adjustable lumbar support",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "secondRowCaptainChairs",
          "label": "Second-row captain's chairs",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerFrontSeats",
          "label": "Power front seats",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "climate",
      "title": "Climate",
      "options": [
        {
          "id": "airConditioning",
          "label": "Air conditioning",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "automaticClimateControl",
          "label": "Automatic climate control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "dualZoneClimateControl",
          "label": "Dual-zone automatic climate control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "rearClimateControl",
          "label": "Rear / tri-zone climate control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "rearPassengerVents",
          "label": "Rear passenger air vents",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "infotainment-connectivity",
      "title": "Infotainment and connectivity",
      "options": [
        {
          "id": "touchscreenDisplay",
          "label": "Touchscreen display",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "appleCarPlay",
          "label": "Apple CarPlay",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "androidAuto",
          "label": "Android Auto",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "bluetoothHandsFree",
          "label": "Bluetooth hands-free",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "usbChargingPorts",
          "label": "USB charging ports",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "wirelessDeviceCharging",
          "label": "Wireless device charging",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "builtInNavigation",
          "label": "Built-in navigation",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "premiumAudioSystem",
          "label": "Premium audio",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "amFmSatelliteRadio",
          "label": "AM/FM / satellite radio",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "inVehicleWifiHotspot",
          "label": "In-vehicle Wi-Fi hotspot",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "steeringWheelAudioControls",
          "label": "Steering-wheel audio controls",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "headUpDisplay",
          "label": "Head-up display",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "safety-driver-assistance",
      "title": "Safety and driver assistance",
      "options": [
        {
          "id": "rearviewCamera",
          "label": "Rearview camera",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "surroundCamera",
          "label": "Surround / 360 camera",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "frontParkingSensors",
          "label": "Front parking sensors",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "rearParkingSensors",
          "label": "Rear parking sensors",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "blindSpotMonitoring",
          "label": "Blind-spot monitoring",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "rearCrossTrafficAlert",
          "label": "Rear cross-traffic alert",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "laneDepartureWarning",
          "label": "Lane departure warning",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "laneKeepingAssist",
          "label": "Lane-keeping assist",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "cruiseControl",
          "label": "Cruise control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "adaptiveCruiseControl",
          "label": "Adaptive cruise control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "forwardCollisionWarning",
          "label": "Forward collision warning",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "automaticEmergencyBraking",
          "label": "Automatic emergency braking",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "antiLockBrakes",
          "label": "Anti-lock brakes (ABS)",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "electronicStabilityControl",
          "label": "Electronic stability control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "tirePressureMonitoring",
          "label": "Tire pressure monitoring (TPMS)",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "parkingSensorsPositionUnknown",
          "label": "Parking sensors",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "exterior-wheels",
      "title": "Exterior and wheels",
      "options": [
        {
          "id": "alloyWheels",
          "label": "Alloy wheels",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "steelWheels",
          "label": "Steel wheels",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "allSeasonTires",
          "label": "All-season tires",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "allTerrainTires",
          "label": "All-terrain tires",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "winterTires",
          "label": "Winter tires",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "sunroofMoonroof",
          "label": "Sunroof / moonroof",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "panoramicRoof",
          "label": "Panoramic roof",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "ledHeadlights",
          "label": "LED headlights",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "fogLights",
          "label": "Fog lights",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "runningBoards",
          "label": "Running boards",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "bedLiner",
          "label": "Bed liner",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "tonneauCover",
          "label": "Tonneau cover",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "roofRails",
          "label": "Roof rails",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "heatedSideMirrors",
          "label": "Heated side mirrors",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerFoldingMirrors",
          "label": "Power-folding side mirrors",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerLiftgate",
          "label": "Power liftgate / tailgate",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "splashGuards",
          "label": "Splash guards",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "convenience-security",
      "title": "Convenience and security",
      "options": [
        {
          "id": "keylessEntry",
          "label": "Keyless entry",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "proximityKey",
          "label": "Proximity key / keyless start",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "pushButtonStart",
          "label": "Push-button start",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "remoteStart",
          "label": "Remote start",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerWindows",
          "label": "Power windows",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerDoorLocks",
          "label": "Power door locks",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerMirrors",
          "label": "Power mirrors",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "powerSteeringColumn",
          "label": "Adjustable power steering column",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "securityAlarm",
          "label": "Security alarm system",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "engineImmobilizer",
          "label": "Engine immobilizer",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "homelink",
          "label": "Garage door opener (HomeLink)",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "autoDimmingMirror",
          "label": "Auto-dimming rearview mirror",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "rainSensingWipers",
          "label": "Rain-sensing wipers",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "towing-equipment",
      "title": "Towing equipment",
      "options": [
        {
          "id": "trailerHitchReceiver",
          "label": "Trailer hitch receiver",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "trailerWiring7Pin",
          "label": "7-pin trailer wiring",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "trailerWiring4Pin",
          "label": "4-pin trailer wiring",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "integratedBrakeController",
          "label": "Integrated trailer brake controller",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "towHaulMode",
          "label": "Tow/haul mode",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "trailerSwayControl",
          "label": "Trailer sway control",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "heavyDutyCoolingPackage",
          "label": "Heavy-duty cooling / tow package",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "fifthWheelGooseneckPrep",
          "label": "Fifth-wheel / gooseneck prep",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "towMirrors",
          "label": "Tow mirrors",
          "defaultStatus": "Not confirmed"
        }
      ]
    },
    {
      "id": "performance",
      "title": "Performance & drive modes",
      "options": [
        {
          "id": "selectableDriveModes",
          "label": "Selectable drive modes",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "performanceBrakes",
          "label": "Performance brakes",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "limitedSlipDifferential",
          "label": "Limited-slip differential",
          "defaultStatus": "Not confirmed"
        },
        {
          "id": "adaptiveSuspension",
          "label": "Adaptive suspension",
          "defaultStatus": "Not confirmed"
        }
      ]
    }
  ]
};
export const FIELD_IDS=new Set(CATALOGUE.groups.flatMap(g=>g.fields.map(f=>f.id)));
export const EQUIPMENT_IDS=new Set(CATALOGUE.equipmentCategories.flatMap(g=>g.options.map(f=>f.id)));
